import { render, staticRenderFns } from "./ManageClinic.vue?vue&type=template&id=1723ee61&scoped=true&"
import script from "./ManageClinic.vue?vue&type=script&lang=js&"
export * from "./ManageClinic.vue?vue&type=script&lang=js&"
import style0 from "./ManageClinic.vue?vue&type=style&index=0&id=1723ee61&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1723ee61",
  null
  
)

export default component.exports